import { Action, createReducer, createSelector, on } from '@ngrx/store';
import { ProductCategoryListResponse, ProductItem, ProductListResponse } from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { productActions } from './product.actions';

export interface ProductsState {
  products: {
    state: ILoaderActionPayload;
    data?: ProductListResponse;
  };
  newProduct: {
    state: ILoaderActionPayload;
    data?: ProductItem;
  };
  loadCategoriesProduct: {
    state: ILoaderActionPayload;
    data?: ProductCategoryListResponse;
  };
}
const initialState: ProductsState = {
  products: { state: { value: LoadingState.NONE } },
  newProduct: { state: { value: LoadingState.SUCCESS } },
  loadCategoriesProduct: { state: { value: LoadingState.NONE } },
};
const reducer = createReducer(
  initialState,
  on(productActions.loadProducts, (state) => ({
    ...state,
    products: { state: { value: LoadingState.LOADING } },
  })),
  on(productActions.loadProductsDone, (state, props) => ({
    ...state,
    products: { state: props.state, data: props.data },
  })),
  on(productActions.createProduct, (state) => ({
    ...state,
    newProduct: { state: { value: LoadingState.LOADING } },
  })),
  on(productActions.createProductDone, (state, props) => ({
    ...state,
    newProduct: { state: props.state, data: props.data },
  })),
  on(productActions.loadProductsCategory, (state) => ({
    ...state,
    loadCategoriesProduct: { state: { value: LoadingState.LOADING } },
  })),
  on(productActions.loadProductsCategoryDone, (state, props) => ({
    ...state,
    loadCategoriesProduct: { state: props.state, data: props.data },
  })),
);
export function productsReducer(state: ProductsState | undefined, action: Action) {
  return reducer(state, action);
}
